export const ADMIN = 1;
export const GAME_PROVIDER = 2;
export const PARTNER = 3;
export const USER = 4;
export const GAME_PROVIDER_EXTENDED = 5;
export const ADMIN_CHAT_MANAGER = 6;

export const humanRoles = {
    [ADMIN]: 'Admin',
    [USER]: 'User',
    //@deprecated
    [GAME_PROVIDER]: 'Game Provider',
    [PARTNER]: 'Partner',
    [GAME_PROVIDER_EXTENDED]: 'Game Provider Extended',
    [ADMIN_CHAT_MANAGER]: 'Admin Chat Manager',
}
